import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import {
  // UploadOutlined,
  PaperClipOutlined,
  AudioOutlined,
} from "@ant-design/icons";
import {
  Button,
  message,
  Input,
  // Avatar,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import throttle from "lodash.throttle";
import { SocketContext } from "../../context/socketContext";
import Typingdots from "../typingdots/typingdots";
import { saveVisitorServed } from "../../redux/VisitorsJoined/VisitorsJoinedActions";
import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
import AudioPlayerCustom from "../audioPlayerCustom/AudioPlayerCustom";
import { FaTrashAlt } from "react-icons/fa";
// import debounce from "lodash.debounce";
import MessagesView from "./messagesView";
import { resolveMessageSenderName } from "../../helpers/conversationDisplay";
import { MAX_CHAT_FILE_BYTES, MAX_CHAT_FILE_SIZE_LABEL } from "../../helpers/attachmentUtils";
import { SOCKET_EVENTS } from "../../constants/socketEvents";

// Visitor message types that are real chat content (and therefore eligible for
// read receipts). System lines like join/leave/widget are excluded.
const RECEIPT_SKIP_TYPES = ["leave", "joiner", "widget", "disconnect"];

// Normalize a raw socket/server payload into the shape the message list renders.
// conversationId is kept so read-receipt emits can update the server-side cache.
const normalizeMessage = (i) => ({
  conversationId: i?.conversationId,
  message: i?.message,
  time: i?.time,
  type: i?.type,
  audio: i?.audio,
  senderID: i?.senderID,
  status: i?.status,
  uniqueMessageID: i?.uniqueMessageID,
  file: i?.file,
  sender: i?.sender,
});

// Merge two message lists, preserving `base` order and appending any items from
// `extra` whose uniqueMessageID is not already present. This lets fetched server
// history coexist with live/seed socket messages without duplicates — and stops
// the first message from being lost when the fetch races ahead of the cache.
const mergeMessagesById = (base, extra) => {
  const seen = new Set(base.map((m) => m?.uniqueMessageID).filter(Boolean));
  const merged = [...base];
  for (const m of extra) {
    if (!m?.uniqueMessageID || seen.has(m.uniqueMessageID)) continue;
    seen.add(m.uniqueMessageID);
    merged.push(m);
  }
  return merged;
};

const DrageCurrentChat = ({
  isAnimation,
  setisAnimation,
  messages,
  setMessages,
  currentActiveVisitorData,
  runAi, setRunAi
}) => {
  const stripEmojis = useMemo(
    () => (text) => (text == null ? "" : String(text).replace(/\p{Extended_Pictographic}/gu, "")),
    []
  );
  const [typedmessage, settypedmessage] = useState("");
  const userData = useSelector((state) => state.Auth.userData);
  // const isLoadClient = useSelector((state) => state.VisitorReducer.isLoadingVisitor);
  const servedData = useSelector((state) => state.VisitorReducer.data);
  const dispatch = useDispatch();
  const [typeData, settypeData] = useState(null);
  const AllShortcuts = useSelector((state) => state.Shortcuts.allShortcuts);
  const overAllUsers = useSelector((state) => state.Users.overAllUsers);
  const { Socket } = useContext(SocketContext);
  const [Typing, setTyping] = useState(false);
  const [currentmsg, setcurrentmsg] = useState("");
  // const [selectedImage, setSelectedImage] = useState(null);
  // const [myIncomingMsgStatus, setmyIncomingMsgStatus] = useState(null);
  const [joindLoading, setjoindLoading] = useState(false);
  const [One_to_One, setOne_to_One] = useState(null);
  const [startRecord, setStartRecord] = useState(false);
  const [audioUrl, setaudioUrl] = useState(null);
  const [audioBlob, setaudioBlob] = useState(null);
  const fileInputRef = useRef(null);
  const recorderControls = useAudioRecorder();
  const [TempFile, setTempFile] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [suggestion, setSuggestion] = useState(null);
  const [AiLoading, setAiLoading] = useState(false);
  const [isAgentBlocked, setIsAgentBlocked] = useState(false);
  // const boxRef = useRef(null);

  // Always-fresh snapshot of the open visitor. Socket handlers below are bound on
  // `unique_id`, which does not change when the agent joins, so reading the live
  // conversation participants from this ref keeps the read-receipt logic accurate
  // without having to re-register the listeners.
  const activeVisitorRef = useRef(currentActiveVisitorData);
  useEffect(() => {
    activeVisitorRef.current = currentActiveVisitorData;
  }, [currentActiveVisitorData]);

  // Keep a fresh servedData snapshot so the socket handlers / maximize effect can
  // read the current serving state without re-subscribing on every change.
  const servedDataRef = useRef(servedData);
  useEffect(() => {
    servedDataRef.current = servedData;
  }, [servedData]);

  // Read-receipt rule for an incoming visitor message:
  //   seen  -> the agent has JOINED this chat AND the drawer is open (maximized)
  //   delivered -> agent online but not joined, or the drawer is minimized
  // Anything for a different visitor stays "delivered".
  // "Joined" mirrors the composer's signal (servedData / servedBy), with
  // agentParticipants only as a fallback — agentParticipants alone can be stale or
  // unpopulated, which previously kept messages stuck on "delivered".
  const isAgentJoined = (visitor) => {
    if (!visitor) return false;
    const servingInStore = servedDataRef.current?.some(
      (it) => String(it?.unique_id) === String(visitor?.unique_id)
    );
    const servedByMe = visitor?.servedBy?.some(
      (item) => String(item?.id) === String(userData?._id)
    );
    const inParticipants = visitor?.current_conversation?.agentParticipants?.some(
      (p) => String(p?._id) === String(userData?._id)
    );
    return !!(servingInStore || servedByMe || inParticipants);
  };
  const resolveIncomingStatus = (senderID) => {
    const active = activeVisitorRef.current;
    if (active?.unique_id !== senderID) return "delivered";
    const isViewing = active?.minimized !== true;
    return isAgentJoined(active) && isViewing ? "seen" : "delivered";
  };

  // Always-fresh messages snapshot so the maximize effect can read the current
  // list without re-running every time a message arrives.
  const messagesRef = useRef(messages);
  useEffect(() => {
    messagesRef.current = messages;
  }, [messages]);

  // Rule: restoring a minimized chat the agent has joined marks every still-unseen
  // visitor message as seen. Emitting visitorMsgToServer fans the receipt out so
  // the change reflects on the widget instantly.
  const wasMinimizedRef = useRef(currentActiveVisitorData?.minimized);
  useEffect(() => {
    if (!Socket) return;
    const minimized = currentActiveVisitorData?.minimized;
    const restoredFromMinimized = wasMinimizedRef.current === true && minimized === false;
    wasMinimizedRef.current = minimized;
    if (!restoredFromMinimized) return;

    const uniqueId = currentActiveVisitorData?.unique_id;
    if (uniqueId) {
      Socket.emit("getVisitorMsg", {
        agentId: userData?._id,
        unique_id: uniqueId,
      }, (res) => {
        if (uniqueId != res?.unique_id) return;
        const serverMessages = (res?.updatedMessages || []).map(normalizeMessage);
        setMessages((prev) => mergeMessagesById(serverMessages, prev));
      });
    }

    if (!isAgentJoined(currentActiveVisitorData)) return;
    const roomId = currentActiveVisitorData?.roomId;
    let changed = false;
    const next = (messagesRef.current || []).map((m) => {
      const isUnseenVisitorMsg =
        String(m?.senderID) === String(uniqueId) &&
        m?.status !== "seen" &&
        !RECEIPT_SKIP_TYPES.includes(m?.type);
      if (!isUnseenVisitorMsg) return m;
      changed = true;
      Socket.emit("visitorMsgToServer", { ...m, status: "seen", to: m?.to || roomId });
      return { ...m, status: "seen" };
    });
    if (changed) setMessages(next);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Socket, currentActiveVisitorData?.minimized, currentActiveVisitorData?.unique_id]);


  // const [api, contextHolder] = notification.useNotification();

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > MAX_CHAT_FILE_BYTES) {
      message.error(`File size exceeds ${MAX_CHAT_FILE_SIZE_LABEL}.`);
    } else {
      await handleUpload(file);
    }
    e.target.value = "";
  };
  const bottomRef = useRef(null);

  const slashMatch = useMemo(() => {
    const txt = currentmsg || "";
    return txt.match(/(?:^|\s)\/([^\s]*)$/);
  }, [currentmsg]);

  const isSlashMode = Boolean(slashMatch);
  const slashQuery = slashMatch ? slashMatch[1] : "";

  const findingTxt = AllShortcuts?.filter(
    (i) =>
      (isSlashMode
        ? (slashQuery !== ""
          ? i?.shortcut?.toLowerCase()?.includes(slashQuery.toLowerCase())
          : true)
        : false) &&
      (i?.available_for?.some((t) => t?._id === userData?._id) ||
        i?.available_for?.some((t) => t?._id === "All-Agents"))
  );

  const shortcutItemRefs = useRef({});

  useEffect(() => {
    if (!isSlashMode) {
      setSelectedIndex(null);
    }
  }, [isSlashMode]);

  useEffect(() => {
    if (!isSlashMode) return;
    if (selectedIndex === null || selectedIndex < 0) return;
    const node = shortcutItemRefs.current?.[selectedIndex];
    if (node && typeof node.scrollIntoView === "function") {
      node.scrollIntoView({ block: "nearest" });
    }
  }, [isSlashMode, selectedIndex]);

  // is Typing
  useEffect(() => {
    if (!Socket) return;

    const handleVisitorTyping = (data) => {
      if (data?.visitorID != currentActiveVisitorData?.unique_id) return;

      if (data?.typing) {
        const modalContent = bottomRef.current?.closest(".chatsMsgs");
        if (modalContent) {
          modalContent.scrollTo({
            top: modalContent.scrollHeight,
            behavior: "smooth",
          });
        }
      }
      setTyping(data?.typing);
      settypedmessage(data?.message ?? "");
      settypeData(null);
    };

    Socket.on("visitorTyping", handleVisitorTyping);
    return () => {
      Socket.off("visitorTyping", handleVisitorTyping);
    };
  }, [Socket, currentActiveVisitorData?.unique_id]);

  useEffect(() => {
    if (!Socket) return;
    const handleUserBlocked = (payload) => {
      const blockedUserId = payload?.userId ?? payload?.userID ?? payload?._id;
      const isBlocked =
        typeof payload?.isBlocked === "boolean"
          ? payload.isBlocked
          : Boolean(payload?.user_status);
      if (!blockedUserId || !isBlocked) return;
      if (String(blockedUserId) === String(userData?._id)) {
        setIsAgentBlocked(true);
        message.error("Your account has been blocked. You can no longer send messages.");
      }
    };
    Socket.on(SOCKET_EVENTS.USER_BLOCKED, handleUserBlocked);
    Socket.on(SOCKET_EVENTS.ADMIN_BLOCKED_USER, handleUserBlocked);
    return () => {
      Socket.off(SOCKET_EVENTS.USER_BLOCKED, handleUserBlocked);
      Socket.off(SOCKET_EVENTS.ADMIN_BLOCKED_USER, handleUserBlocked);
    };
  }, [Socket, userData?._id]);

  //Getting Visitor MEssages
  useEffect(() => {
    if (!Socket) return;

    const handleStatusUpdate = ({ id, status }) => {
      setisAnimation(false);
      setMessages((prev) =>
        prev.map((msg) => (msg.uniqueMessageID === id ? { ...msg, status } : msg))
      );
    };

    const handleVisitorStatusUpdate = (data) => {
      if (currentActiveVisitorData?.unique_id == data?.senderID) {
        const nextStatus = resolveIncomingStatus(data?.senderID);
        // Dedupe by uniqueMessageID so a line that also arrives via the brand-wide
        // fan-out (visitorChatToBrand) can never be appended twice.
        setMessages((prev) => {
          const uid = data?.uniqueMessageID;
          if (uid && prev?.some((m) => m?.uniqueMessageID === uid)) {
            return prev.map((m) => (m?.uniqueMessageID === uid ? { ...m, ...data, status: nextStatus } : m));
          }
          return [...prev, { ...data, status: nextStatus }];
        });
        setRunAi(true);
        setisAnimation(true);
        const updatedData = {
          ...data,
          status: nextStatus,
          to: data?.to || activeVisitorRef.current?.roomId,
        };
        Socket.emit("visitorMsgToServer", updatedData);
      }
    };

    const handleConvoAllMessages = (data) => {
      if (data === null) return;
      if (currentActiveVisitorData?.unique_id != data?.unique_id) return;
      setMessages([]);
      data?.updatedMessages?.map((i) => {
        return setMessages((current) => [
          ...current,
          {
            message: i?.message,
            time: i?.time,
            type: i?.type,
            audio: i?.audio,
            senderID: i?.senderID,
            status: i?.status,
            uniqueMessageID: i?.uniqueMessageID,
            file: i?.file,
          },
        ]);
      });
    };

    Socket.on("agentMessagefromServer", handleStatusUpdate);
    Socket.on("visitorFirstMessage", handleVisitorStatusUpdate);
    Socket.on("convoAllMessages", handleConvoAllMessages);

    return () => {
      Socket.off("agentMessagefromServer", handleStatusUpdate);
      Socket.off("visitorFirstMessage", handleVisitorStatusUpdate);
      Socket.off("convoAllMessages", handleConvoAllMessages);
    };

  }, [Socket, currentActiveVisitorData?.unique_id]);

  // Load the conversation history when the open visitor changes. We clear first
  // so the previous visitor's messages never bleed in, then MERGE the fetched
  // history with whatever already arrived for this visitor (live socket lines or
  // the seeded first message) instead of overwriting — so the first message is
  // never dropped just because the fetch ran before it was cached.
  useEffect(() => {
    if (!Socket || !currentActiveVisitorData?.unique_id) return;
    const targetId = currentActiveVisitorData?.unique_id;
    setMessages([]);
    setisAnimation(false);
    Socket.emit("getVisitorMsg", {
      agentId: userData?._id,
      unique_id: targetId,
    }, (res) => {
      if (targetId != res?.unique_id) return;
      const serverMessages = (res?.updatedMessages || []).map(normalizeMessage);
      setMessages((prev) => mergeMessagesById(serverMessages, prev));
    });

    return () => {
      Socket.off("getVisitorMsg");
    };
  }, [Socket, currentActiveVisitorData?.unique_id, currentActiveVisitorData?.current_conversation?._id]);

  // When the drawer is auto-opened by a visitor's first message, that message
  // was delivered before this component mounted, so it isn't in state yet. The
  // parent seeds it on the visitor object — append it (deduped) so it shows
  // immediately, without waiting for a reopen/refetch.
  useEffect(() => {
    const seed = currentActiveVisitorData?.seedMessage;
    if (!seed?.uniqueMessageID) return;
    if (String(seed?.senderID) !== String(currentActiveVisitorData?.unique_id)) return;
    setMessages((prev) => mergeMessagesById(prev, [normalizeMessage(seed)]));
    setisAnimation(true);
  }, [currentActiveVisitorData?.unique_id, currentActiveVisitorData?.seedMessage?.uniqueMessageID]);

  useEffect(() => {
    if (runAi === true && currentActiveVisitorData?.current_conversation?.agentParticipants
      ?.some(participant => participant._id === userData?._id)) {
      let lastMessage = messages[messages.length - 1];
      if (lastMessage?.sender && lastMessage?.sender !== "agent") {
        setAiLoading(true);
        Socket.emit("suggestReply",
          {
            conversation: messages,
            unique_id: currentActiveVisitorData?.unique_id,
            websiteToken: currentActiveVisitorData.websiteToken
          }, (data) => {
            if (data === null) {
              setAiLoading(false);
              setRunAi(false);
            }
            else {
              setAiLoading(false);
              setRunAi(false);
              if (currentActiveVisitorData?.unique_id !== data?.unique_Id) return;
              setSuggestion(data || null);
            }
          });

      }
    }
  }, [runAi, currentActiveVisitorData]);

  useEffect(() => {
    if (One_to_One !== null) {
      if (currentActiveVisitorData?.unique_id == One_to_One?.senderID) {
        const nextStatus = resolveIncomingStatus(One_to_One?.senderID);
        setMessages((prev) => [
          ...prev,
          {
            file: One_to_One.file,
            audio: One_to_One.audio,
            message: One_to_One.message,
            name: One_to_One?.senderID,
            senderID: One_to_One?.senderID,
            to: One_to_One?.to,
            uniqueMessageID: One_to_One?.uniqueMessageID,
            time: One_to_One?.time,
            type: One_to_One?.type,
            status: nextStatus,
          },
        ]);
        const updatedData = {
          ...One_to_One,
          status: nextStatus,
          to: One_to_One?.to || currentActiveVisitorData?.roomId,
        };
        Socket.emit("visitorMsgToServer", updatedData);

      }
      setOne_to_One(null);

    }
  }, [One_to_One]);


  const { TextArea } = Input;

  const handleUpload = async (selectedFile) => {
    if (isAgentBlocked) return;
    if (selectedFile) {
      setisAnimation(true);
      let body;
      try {
        body = await selectedFile.arrayBuffer();
      } catch (err) {
        console.error(err);
        message.error("Could not read file for upload.");
        setisAnimation(false);
        return;
      }
      let fileInfo = {
        filename: selectedFile?.name,
        filetype: selectedFile?.type,
        fileSize: selectedFile?.size,
        body,
      };
      const uniqueNumber = Date.now() + userData?._id;
      // const conversationId = currentActiveVisitorData?.current_conversation?._id ||
      //   servedData?.find(x => x?.unique_id === currentActiveVisitorData?.unique_id)?.convoID;
      let messagePayload = {
        conversationId: currentActiveVisitorData?.current_conversation?._id,
        reciver: currentActiveVisitorData?.unique_id,
        name: userData?.sudoName,
        senderID: userData?._id,
        message: stripEmojis(currentmsg).trim(),
        file: fileInfo,
        audio: null,
        to: currentActiveVisitorData?.roomId,
        status: "wait",
        type: "file",
        uniqueMessageID: uniqueNumber
      };
      setMessages((current) => [...current, messagePayload]);
      Socket.emit("sendMessageToVisitor", { ...messagePayload },
        (data) => {
          if (data?.error || data?.status === "failed") {
            message.error(data?.error || "File failed to send.");
            setMessages((prev) => prev.filter((msg) => msg.uniqueMessageID !== uniqueNumber));
            setisAnimation(false);
            return;
          }
          setMessages((prev) =>
            prev.map((msg) =>
              msg.uniqueMessageID === uniqueNumber ? { ...msg, id: data.id, status: "sent" } : msg
            )
          );
        });
      setcurrentmsg("");
      setaudioBlob(null);
      setaudioUrl(null);
      document.getElementById("file").value = "";
    }
  };
  const beforeUpload = (file) => {
    const allowedExtensions = ["png", "jpg", "jpeg", "doc", "docx", "xls", "xlsx", "pdf"];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    const isAllowed = allowedExtensions.includes(fileExtension);
    if (!isAllowed) {
      message.error("You can only upload PNG, JPG, JPEG, DOC, DOCX, XLS, XLSX, or PDF files.");
    } else {
      if (file.size > MAX_CHAT_FILE_BYTES) {
        message.error(`File size exceeds ${MAX_CHAT_FILE_SIZE_LABEL}.`);
        setTimeout(() => {
          setcurrentmsg("");
        }, 100);
      }
      else {
        handleUpload(file);
        setTimeout(() => {
          setcurrentmsg("");
        }, 100);
      }
    }
    return false;
  };
  const props = {
    beforeUpload,
    showUploadList: false,
  };


  const sendtoClint = () => {
    if (isAgentBlocked) return;

    const cleanedText = stripEmojis(currentmsg).trim();
    if (cleanedText !== "" || audioUrl !== null) {
      setisAnimation(true);
      const uniqueNumber = Date.now() + userData?._id;
      // const conversationId = currentActiveVisitorData?.current_conversation?._id ||
      //   servedData?.find(x => x?.unique_id === currentActiveVisitorData?.unique_id)?.convoID;
      const messagePayload = {
        conversationId: currentActiveVisitorData?.current_conversation?._id,
        name: userData?.sudoName,
        to: currentActiveVisitorData?.roomId,
        message: audioUrl ? "" : cleanedText,
        senderID: userData?._id,
        file: null,
        audio: audioUrl ? audioBlob : null,
        type: "text",
        status: "wait",
        id: suggestion?.id || null,
        uniqueMessageID: uniqueNumber,
        reciver: currentActiveVisitorData?.unique_id
      };
      setMessages((current) => [...current, messagePayload]);
      Socket.emit("sendMessageToVisitor", { ...messagePayload },
        (data) => {
          if (data?.error || data?.status === "failed") {
            message.error(data?.error || "Message failed to send.");
            setMessages((prev) => prev.filter((msg) => msg.uniqueMessageID !== uniqueNumber));
            setisAnimation(false);
            return;
          }
          setMessages((prev) =>
            prev.map((msg) =>
              msg.uniqueMessageID === uniqueNumber ? { ...msg, id: data.id, status: "sent" } : msg
            )
          );
        });
      if (!audioUrl) setcurrentmsg("");
      setaudioBlob(null);
      setaudioUrl(null);
      setSuggestion(null);
      stopTyping(currentActiveVisitorData?.roomId);
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.keyCode === 13 && !event.shiftKey) {
        event.preventDefault();
        if (audioUrl) {
          sendtoClint();
        }
      }
    };

    if (audioUrl) {
      document.addEventListener("keydown", handleKeyPress);
    } else {
      document.removeEventListener("keydown", handleKeyPress);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [audioUrl]);

  /// onClick Join Chat
  const startChatNow = () => {
    if (isAgentBlocked) return;
    setjoindLoading(true);
    setRunAi(true);
    Socket.emit("visiterServed", {
      unique_id: currentActiveVisitorData?.unique_id,
      agentID: userData?._id,
    }, (respone) => {
      dispatch(saveVisitorServed({ unique_id: respone?.unique_id, convoID: respone?.convoId }, servedData));
      setjoindLoading(false);
    });
  };

  const typingTimeoutRef = useRef(null);

  const handleTyping = useMemo(
    () =>
      throttle((roomId) => {
        if (!Socket || !roomId) return;
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        Socket.emit("startTyping", { typing: true, roomId });
        typingTimeoutRef.current = setTimeout(() => {
          Socket.emit("startTyping", { typing: false, roomId });
          typingTimeoutRef.current = null;
        }, 3000);
      }, 2000),
    [Socket]
  );

  const stopTyping = (roomId) => {
    handleTyping.cancel();
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
      typingTimeoutRef.current = null;
    }
    if (!Socket || !roomId) return;
    Socket.emit("startTyping", { typing: false, roomId });
  };

  useEffect(() => {
    return () => {
      handleTyping.cancel();
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    };
  }, [handleTyping]);

  const sentToVisitor = (e) => {
    setcurrentmsg(stripEmojis(e.target.value));
    setSelectedIndex(null);
    handleTyping(currentActiveVisitorData?.roomId);
  };

  const something = (event) => {
    const hasSuggestions = isSlashMode && findingTxt?.length > 0;
    if (hasSuggestions) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setSelectedIndex((prev) => {
          if (prev === null || prev === -1) return 0;
          if (prev < findingTxt.length - 1) return prev + 1;
          return prev;
        });
        return;
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        setSelectedIndex((prev) => {
          if (prev === null) return -1;
          if (prev > -1) return prev - 1;
          return prev;
        });
        return;
      }


      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        const selectedItem = selectedIndex === null ? findingTxt[0] : findingTxt[selectedIndex];
        if (selectedItem) {
          onetxtchange(selectedItem.message, selectedItem.options);
          return;
        }
      }
    }

    // Send message if no suggestions are open
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (currentmsg?.trim()) {
        sendtoClint();
      }
      return;
    }

    // Shift + Enter for newline
    if (event.key === 'Enter' && event.shiftKey) {
      event.preventDefault();
      setcurrentmsg((prev) => prev + '\n');
    }
    if (event.key === "Tab" && suggestion) {
      event.preventDefault();                      // keep focus, no tab‑jump
      setcurrentmsg(suggestion?.reply);               // fill the text area                      // clear ghost text
      return;
    }
  };

  const onetxtchange = (i, u) => {
    if (u?.length > 0) {
      let abc = u?.map((b, index) =>
        index + 1 !== u?.length ? b?.option + "\n" : b?.option
      );
      let wow = abc.join("");
      const replacement = i + "::" + "\n" + wow?.toString();
      setcurrentmsg((prev) => {
        if (!slashMatch) return replacement;
        return prev.replace(/(?:^|\s)\/([^\s]*)$/, (m) =>
          m.replace(/\/([^\s]*)$/, replacement)
        );
      });
    } else {
      const replacement = i;
      setcurrentmsg((prev) => {
        if (!slashMatch) return replacement;
        return prev.replace(/(?:^|\s)\/([^\s]*)$/, (m) =>
          m.replace(/\/([^\s]*)$/, replacement)
        );
      });
    }
    setSelectedIndex(null);
  };

  useEffect(() => {
    const modalContent = bottomRef.current.closest(".chatsMsgs");
    if (modalContent) {
      modalContent.scrollTo({
        top: modalContent.scrollHeight,
        behavior: "smooth",
      });
      if (isAnimation) {
        modalContent.scrollTo({
          top: modalContent.scrollHeight,
          behavior: "smooth",
        });
      } else {
        modalContent.scrollTo({
          top: modalContent.scrollHeight,
        });
      }
    }
    const lastMsg = messages?.[messages.length - 1];
    const isFromVisitor =
      lastMsg &&
      (lastMsg?.sender === "visitor" ||
        String(lastMsg?.senderID) === String(currentActiveVisitorData?.unique_id));
    if (isFromVisitor) {
      settypedmessage("");
      setTyping(false);
    }
  }, [messages, currentActiveVisitorData?.unique_id]);


  // emoji picker removed (agent and visitor can't send emojis)

  const handlePaste = (event) => {
    const clipboardData = event.clipboardData || window.clipboardData;
    const items = clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      // Check if the item is an image
      if (item.type.startsWith('image/')) {
        const file = item.getAsFile();
        beforeUpload(file);
      };
    }
  }
  const addAudioElement = (blob) => {
    if (TempFile !== blob) {
      if (!recorderControls?.isRecording) {
        const url = URL.createObjectURL(blob);
        setaudioBlob({
          audio: blob,
          filename: `audio_${Date.now()}.webm`,
        });
        setaudioUrl(url);
        setTempFile(blob);
      }
    }
  };

  const onToggleBtn = () => {
    setStartRecord(true);
    setTimeout(() => {
      recorderControls.startRecording();
    }, 200);
  };

  useEffect(() => {
    if (!recorderControls?.recordingBlob) return;
    setTimeout(() => {
      setStartRecord(false);
    }, 200);
  }, [recorderControls?.recordingBlob]);

  const RemoveRecordedAudio = () => {
    setaudioBlob(null);
    setaudioUrl(null);
  };

  const ghost = suggestion?.reply?.startsWith(currentmsg) ? suggestion?.reply?.slice(currentmsg?.length) : "";

  return (
    <div className="chatArea chatVisitorDrawer__chatArea">
      <div className="chatsMsgs chatVisitorDrawer__chatsMsgs">
        <div>
          {/* {Loading && <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 50 }}> <Spin /></div>} */}
          {messages?.map((i, index) => {
            const updatedName = resolveMessageSenderName({
              message: i,
              currentConversation: currentActiveVisitorData?.current_conversation,
              overAllUsers,
            });
            return (
              <MessagesView key={index} i={i} updatedName={updatedName} userData={userData} />
            );
          })}
          {Typing && (
            <div
              className="conversation-list"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div
                className="chat-avatar"
                style={{
                  color: "dimgrey",
                  fontStyle: "italic",
                }}
              >
                visitor is typing
              </div>
              <div className="user-chat-content">
                <div style={{ marginBottom: 4, marginLeft: 4 }}>
                  <span
                    style={{ textAlign: "center", padding: "0px 5px" }}
                    color="#000"
                  >
                    <Typingdots />
                  </span>
                </div>
                {/* <div className="conversation-name">#[{updatedName}]</div> */}
              </div>
            </div>
          )}
          <div ref={bottomRef} />
        </div>
      </div>

      <div className="chatVisitorDrawer__composerSection">
        {servedData?.some(
          (it) => it?.unique_id == currentActiveVisitorData?.unique_id
        ) ||
          (currentActiveVisitorData?.servedBy?.length > 0 &&
            currentActiveVisitorData?.servedBy?.find(
              (item) => item.id === userData?._id
            )) ? (
          <div className="bottom_text_wrapper chatVisitorDrawer__bottomBar">
            <div
              style={{
                marginTop: -5,
                marginBottom: 1,
                fontStyle: "italic",
                color: "dimgrey",
                paddingBottom: "6px",
              }}
            >
              {/* Visitor : */}
              <input
                type="text"
                value={typedmessage}
                readOnly
                style={{
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  color: "dimgrey",
                  fontStyle: "italic",
                  paddingBottom: "6px",
                  textAlign: "left",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  direction: "rtl",
                  width: "100%",
                }}
              />
            </div>
            {startRecord && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "0px 20px",
                  position: "absolute",
                  top: "85px",
                  width: "89%",
                  left: 0,
                  zIndex: 9999,
                }}
              >
                <AudioRecorder
                  onRecordingComplete={(e) => addAudioElement(e)}
                  recorderControls={recorderControls}
                  downloadFileExtension={"mp3"}
                  showVisualizer={true}
                  classes={{ AudioRecorderStartSaveClass: "save_audio_recorder" }}
                />
              </div>
            )}
            <div className="chatVisitorDrawer__composerWrap">
              {isAgentBlocked && (
                <p style={{ color: "#cf1322", marginBottom: 8 }}>
                  Your account has been blocked. Messaging is disabled.
                </p>
              )}
              {audioUrl ? (
                <></>
              ) : (
                <>
                  <TextArea
                    className="chatVisitorDrawer__composer"
                    style={{
                      height: 110,
                      resize: "none",
                    }}
                    onPaste={handlePaste}
                    onKeyDown={(e) => something(e)}
                    value={currentmsg}
                    onChange={(e) => sentToVisitor(e)}
                    placeholder={ghost ? ghost : "Type your message…"}
                    disabled={isAgentBlocked}
                  />
                  {AiLoading && <h5 style={{
                    position: "absolute",
                    top: -10,
                    right: 10,

                  }}>suggestion answaer...</h5>}
                  {/* AiLoading */}
                </>

              )}

              {audioUrl && (
                <div className="send_audio_wrapper">
                  <AudioPlayerCustom audioUrl={audioUrl} />
                  <FaTrashAlt
                    className="trash_audio"
                    onClick={() => RemoveRecordedAudio()}
                  />
                </div>
              )}

              {isSlashMode && findingTxt?.length > 0 && (
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 1,
                    borderBottomLeftRadius: 5,
                    width: "100%",
                    overflowY: "scroll",
                    height: 40,
                  }}
                >
                  {findingTxt?.map((i, index) => (
                    <div
                      key={index}
                      ref={(el) => {
                        if (el) shortcutItemRefs.current[index] = el;
                      }}
                      onClick={() => onetxtchange(i?.message, i?.options)}
                      style={{
                        backgroundColor: selectedIndex == index ? "#1890ff" : "#D3D3D3",
                        color: selectedIndex == index ? "white" : "inherit",
                        fontSize: 14,
                        cursor: "pointer",
                        padding: "6px 8px",
                      }}
                    >
                      {i?.shortcut} : {i?.message}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="footerChat">
              <input
                id="file"
                type="file"
                accept=".png, .jpg, .jpeg, .doc, .docx, .xls, .xlsx, .pdf"
                onChange={handleFileChange}
                style={{ display: "none" }}
                ref={fileInputRef}
              />
              {audioUrl ? (
                <></>
              ) : (
                <>
                  {/* Emoji picker disabled */}
                  <Button
                    onClick={() => onToggleBtn()}
                    style={{ marginRight: 5, paddingTop: 5 }}
                    type="primary"
                    icon={<AudioOutlined />}
                    disabled={isAgentBlocked}
                  >
                    {/* <Recoder /> */}
                  </Button>
                  <Button
                    onClick={() => fileInputRef.current.click()}
                    style={{ marginRight: 5, paddingTop: 5 }}
                    type="primary"
                    icon={<PaperClipOutlined />}
                    disabled={isAgentBlocked}
                  >
                    {/* <Recoder /> */}
                  </Button>
                  {/* <Button
                    style={{ marginRight: 5 }}
                    onClick={() => fileInputRef.current.click()}
                    type="primary"
                    icon={<PaperClipOutlined />}
                  >
                    Select File
                  </Button> */}
                </>
              )}
              <Button
                style={{ marginRight: 2 }}
                onClick={() => sendtoClint()}
                type="primary"
                disabled={isAgentBlocked}
              >
                Send
              </Button>
            </div>
          </div>
        ) : (
          <div className="chatVisitorDrawer__joinPanel">
            <button
              type="button"
              className="chatVisitorDrawer__joinLink"
              disabled={joindLoading}
              onClick={() => startChatNow()}
            >
              Join to send messages to this visitor.
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DrageCurrentChat;
